<template>
  <RouterView />
  <Toast />
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { RouterView } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useToastStore } from '@/stores/toast'
import { useQesReturnNotice } from '@/composables/useQesReturnNotice'
import Toast from 'primevue/toast'
import { useToast } from 'primevue'

const { reset } = useToastStore()
const { messages } = storeToRefs(useToastStore())
const toast = useToast()

useQesReturnNotice()

watch(
  () => messages.value.length,
  () => {
    messages.value.forEach((message) => {
      toast.add(message)
    })

    reset()
  }
)
</script>
